import { MINERVA_API_URL } from '@/config';
import { http } from '@/plugins/http';

import * as types from './mutation-types';

export function createSharedPage({ dispatch }, data) {
  return http.post(`${MINERVA_API_URL}/shared_pages`, data)
    .then(res => dispatch('setSharedPageInfo', res.data))
    .catch(err => Promise.reject(err.respoonse));
}

export function fetchSharedPage({ dispatch }, params) {
  return http.get(`${MINERVA_API_URL}/shared_page`, { params })
    .then(res => dispatch('setSharedPage', res.data))
    .catch(err => Promise.reject(err.respoonse));
}

export function createSharedPageResults({ dispatch }, data) {
  return http.post(`${MINERVA_API_URL}/shared_page_results`, data)
    .then(res => dispatch('setSharedPageResults', res.data))
    .catch(err => Promise.reject(err.respoonse));
}

export function fetchSharedPageResult({ dispatch }, params) {
  return http.get(`${MINERVA_API_URL}/shared_page_result`, { params })
    .then(res => dispatch('setSharedPageResults', res.data))
    .catch(err => Promise.reject(err.respoonse));
}

export function setSharedPageInfo({ commit }, data) {
  commit(types.SET_SHARED_PAGE_INFO, data);

  return Promise.resolve(data);
}
export function setSharedPage({ commit }, data) {
  commit(types.SET_SHARED_PAGE, data);

  return Promise.resolve(data);
}

export function setSharedPageResults({ commit }, data) {
  commit(types.SET_SHARED_PAGE_RESULTS, data);

  return Promise.resolve(data);
}

export function setSharedQuizOption({ commit }, data) {
  return commit(types.SET_SHARED_QUIZ_OPTION, data);
}
